export interface RenderMetricSample {
  layoutType: string;
  pageType: string;
  actualDuration: number;
  baseDuration: number;
  phase: 'mount' | 'update' | (string & {});
  timestamp?: number;
}

export interface RenderMetricSummaryItem {
  layoutType: string;
  pageType: string;
  count: number;
  avgActualDuration: number;
  avgBaseDuration: number;
  maxActualDuration: number;
  maxBaseDuration: number;
  overBudgetCount: number;
}

interface AggregateBucket {
  layoutType: string;
  pageType: string;
  count: number;
  totalActualDuration: number;
  totalBaseDuration: number;
  maxActualDuration: number;
  maxBaseDuration: number;
  overBudgetCount: number;
}

const FRAME_BUDGET_MS = 16;

export class RenderMetricsCollector {
  private readonly buckets = new Map<string, AggregateBucket>();

  add(sample: RenderMetricSample): void {
    const key = `${sample.layoutType}:${sample.pageType}`;
    const bucket = this.buckets.get(key) ?? {
      layoutType: sample.layoutType,
      pageType: sample.pageType,
      count: 0,
      totalActualDuration: 0,
      totalBaseDuration: 0,
      maxActualDuration: 0,
      maxBaseDuration: 0,
      overBudgetCount: 0,
    };

    bucket.count += 1;
    bucket.totalActualDuration += sample.actualDuration;
    bucket.totalBaseDuration += sample.baseDuration;
    bucket.maxActualDuration = Math.max(bucket.maxActualDuration, sample.actualDuration);
    bucket.maxBaseDuration = Math.max(bucket.maxBaseDuration, sample.baseDuration);
    if (sample.actualDuration > FRAME_BUDGET_MS) {
      bucket.overBudgetCount += 1;
    }

    this.buckets.set(key, bucket);
  }

  getSummary(): RenderMetricSummaryItem[] {
    return [...this.buckets.values()].map((bucket) => ({
      layoutType: bucket.layoutType,
      pageType: bucket.pageType,
      count: bucket.count,
      avgActualDuration: bucket.totalActualDuration / bucket.count,
      avgBaseDuration: bucket.totalBaseDuration / bucket.count,
      maxActualDuration: bucket.maxActualDuration,
      maxBaseDuration: bucket.maxBaseDuration,
      overBudgetCount: bucket.overBudgetCount,
    }));
  }

  reset(): void {
    this.buckets.clear();
  }
}
